import { ProfileRenderer } from './renderers/profile.renderer';
import { OrganizationRenderer } from './renderers/organization.renderer';
import { FormRenderer } from './renderers/form.renderer';
import { DataEntryHistoryRenderer } from './renderers/dataentry.history.renderer';
import { FormCheckRenderer } from './renderers/form.check.renderer';
import { StringRenderer } from './renderers/string.renderer';

export interface IRenderer {
  RenderHeader(preview: any): string;
  RenderBody(preview: any): string;
}

export class RendererFactory {

  public static Profile = new RendererFactory(new ProfileRenderer());
  public static Organization = new RendererFactory(new OrganizationRenderer());
  public static Form = new RendererFactory(new FormRenderer());
  public static DataEntryHistory = new RendererFactory(new DataEntryHistoryRenderer());
  public static FormCheck = new RendererFactory(new FormCheckRenderer());
  public static String = new RendererFactory(new StringRenderer());
  
  public readonly Renderer: IRenderer;

  private constructor(renderer: IRenderer) {
    this.Renderer = renderer;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderer.ts